// Backend JWT issued on OTP verification (routers/otp.py verify_otp,
// routers/email.py verify_email_otp). services/api.ts attaches it as
// `Authorization: Bearer <token>` on every request; the backend's
// resolve_caller_mobile prefers it over the legacy x-*-mobile headers this
// dashboard still sends, and requires it outright once IS_AUTH_ENABLED is on.
const TOKEN_KEY = 'ak_dashboard_token';

export const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setAuthToken = (token: string | null | undefined): void => {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    // ignore storage errors (e.g. private browsing / storage disabled)
  }
};

export const clearAuthToken = (): void => setAuthToken(null);
